import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'timeline.timeline_title',
    defaultMessage: 'Timeline',
  },
  title_penalties: {
    id: 'timeline.penalties_title',
    defaultMessage: 'Penalty Kicks',
  },
  segment_halftime: {
    id: 'timeline.segment_halftime',
    defaultMessage: 'HALFTIME',
  },
  segment_extra_time: {
    id: 'timeline.segment_extra_time',
    defaultMessage: 'EXTRA TIME',
  },
});
